import { Injectable } from "@angular/core";
import { AdaptClientConfiguration, AdaptProject } from "@common/configuration/adapt-client-configuration";
import { ActivityPage } from "@org-common/lib/activities/activities-metadata";
import { IActivityFilterParams } from "@org-common/lib/activities/activity-filter/activity-filter.component";
import { OrganisationService } from "@org-common/lib/organisation/organisation.service";
import { Subject } from "rxjs";

@Injectable({
    providedIn: "root",
})
// stores the state of the activity page between navigation
export class ActivityPageService {
    public readonly defaultPage = AdaptClientConfiguration.AdaptProjectName === AdaptProject.Alto
        ? ActivityPage.Pathway
        : ActivityPage.Activity;

    private filterParams?: IActivityFilterParams;
    private filterUpdated = new Subject<IActivityFilterParams | undefined>();
    public filterUpdated$ = this.filterUpdated.asObservable();

    public page = this.defaultPage;
    public schedulerDate = new Date();

    public get filter() {
        return this.filterParams;
    }

    public set filter(filter: IActivityFilterParams | undefined) {
        this.filterParams = filter;
        this.filterUpdated.next(this.filterParams);
    }

    public constructor(organisationService: OrganisationService) {
        // reset the filter when changing organisations
        // otherwise if you go to an org with some features disabled, then back to a full one,
        // filter will be hiding previously disabled.
        organisationService.organisationChanged$.subscribe(() => this.filterParams = undefined);
    }
}
